<script setup>
import { ref, onMounted, defineEmits, inject, watch } from 'vue';
import countryListData from '@/utils/country.js';
import CountryFlag from 'vue-country-flag-next'
import { showMessage } from "@/utils/hooks/message"
import { uploadFile, getFileUrl } from "@/service";
import Swal from "sweetalert2";
import i18n from "@/i18n"
// import flatPickr from "vue-flatpickr-component";
import { AreaJson } from "@/utils/china.js"
import { getLangValue } from "@/utils/common"; //获取后端语言
// import fileActionCom from "@/components/common/fileAction.vue";
const isCheckForm = ref(false)
const formData = ref({
    // Enterprise_registered_country: '',
    Enterprise_registered_countryKey: '',
    // Enterprise_registered_address: '',
    Certificate_No: '',
    qualification_documents: [],
    logo: [],
    //新增字段
    company_qualification_validity_period: '', //机构资质认证有效期
    company_qualification_certification_body: '', //机构资质认证机构
    company_website: '', //公司官网网址

})
const countryList = ref(countryListData);
const countryList1 = ref(countryListData);
// const accept = '.png,.jpeg,.jpg,'
const emits = defineEmits(['nextStep'])
const detailInfo = inject('detailInfo',)
const cityList = ref([])
const oldCityList = ref([])
const provinceList = ref([])
const cityList1 = ref([])
const oldCityList1 = ref([])
const provinceList1 = ref([])
const uploadRef = ref(null)
const uploadRef1 = ref(null)
const companytype = inject('company_type')
const productCompanyIdList = ["1","2","3","4","5","9","10"]; // 这些企业类型可以填写生产地址 但不是必填 2026-07-01
const productCompanyIdList1 = ["1","3","4","5","9","10"]; // 这些企业类型可以填写生产地址 也可以删除 制造商 不可以
const shortcuts = [
    {
        text:  getLangValue("base.permanent"),
        value: `9999-12-31`,
    },
];
const contact_address = ref([{
    country: '',
    countryKey: '',
    province: '',
    city: '',
    address: '',
    post: '',
}])
const companyAddressList = ref([
    {
        country: '',
        countryKey: '',
        province: '',
        province_code: '',
        city: '',
        address: '',
        post: '',
    },
    // {
    //     country: '',
    //     countryKey: '',
    //     province: '',
    //     city: '',
    //     address: '',
    //     post: '',
    // }
])

const addAddress = () => {
    // 添加企业生产地址
    companyAddressList.value.push({
        id: '',
        country: '',
        countryKey: '',
        province: '',
        province_code: '',
        city: '',
        address: '',
        post: '',
    })
}
const removeProductAddress = (key) => {
    // 删除企业生产地址
    Swal.fire({
        title: getLangValue("base.delete_alert_title"),
        text: getLangValue("base.delete_alert_info"),
        icon: "warning",
        showCancelButton: true,
        cancelButtonColor: "#f46a6a",
        confirmButtonColor: "#34c38f",
        confirmButtonText: getLangValue("base.done"),
        cancelButtonText: getLangValue("base.cancel"),
    }).then(async (result) => {
        if (result.isConfirmed) {
            companyAddressList.value.splice(key, 1);
        }
    });
}
const filterCountry = (query) => {
    // 搜索国家
    if (query) {
        countryList.value = countryList1.value.filter((item) => {
            if ((item.zh.toLowerCase()).includes(query.toLowerCase()) || (item.en.toLowerCase()).includes(query.toLowerCase()) ) {
                return true
            }
        })
    } else {
        countryList.value = [...countryList1.value] //val为空时，还原数组
    }
}

const filterProvince = (query, key) => {
    // 搜索省份  自带的搜索不管用  
    // console.log(query);
    if (query) {
        provinceList.value[key] = AreaJson.filter((item) => {
            if (item.name.includes(query)) {
                return true
            }
        })
    } else {
        provinceList.value[key] = [...AreaJson] //val为空时，还原数组
    }
}

const filterCity = (query, key) => {
    // 搜索省份  自带的搜索不管用 
    // console.log(query);
    if (query) {
        cityList.value[key] = oldCityList.value[key].filter((item) => {
            if (item.name.includes(query)) {
                return true
            }
        })
    } else {
        cityList.value[key] = [...oldCityList.value[key]] //val为空时，还原数组
    }
}

const changeCountry = (key) => {
    // 选择国家 展示对应的key
    if (!companyAddressList.value[key].country) {
        companyAddressList.value[key].countryKey = ''
    } else {
        let arr = countryList.value.filter(item => item.zh === companyAddressList.value[key].country || item.en === companyAddressList.value[key].country)
        if (arr.length > 0) {
            companyAddressList.value[key].countryKey = arr[0].key
        }
    }
    // 如果是中国
    if (companyAddressList.value[key].countryKey == 'CN') {
        provinceList.value[key] = [...AreaJson]
    }
}

// const changeAddressCountry = () => {
//     // 选择国家 展示对应的key
//     if (!formData.value.Enterprise_registered_country) {
//         formData.value.Enterprise_registered_countryKey = ''
//     } else {
//         let arr = countryList.value.filter(item => item.zh === formData.value.Enterprise_registered_country)
//         if (arr.length > 0) {
//             formData.value.Enterprise_registered_countryKey = arr[0].key
//         }
//     }
// }

// const getCountrykey = (country) => {
//     if (country) {
//         let arr = countryList.value.filter(item => item.zh === country)
//         if (arr.length > 0) {
//             return arr[0].key
//         }
//     }
//     return ''
// }

const checkContactAddress = () => {
    // check 企业通讯地址都需要填写
    let checkRes = true
    for (const item in contact_address.value) {
        if (!contact_address.value[item].countryKey ||
            !contact_address.value[item].province ||
            !contact_address.value[item].city ||
            !contact_address.value[item].address ||
            !contact_address.value[item].post) {
            checkRes = false
            break;
        }
    }
    return checkRes;
}
const checkForm = () => {
    //验证表单信息
    isCheckForm.value = true;
    let checkRes = true
    console.log(companytype);
    for (const item in formData.value) {
        if (item == 'qualification_documents') { // 去掉logo || item == 'logo'
            if (item == 'qualification_documents' && formData.value[item].length == 0) {
                checkRes = false
                break;
            }
        } else if (item == 'company_qualification_validity_period' || item == 'company_qualification_certification_body') {
            // 只有检测机构需要填写
            if (companytype.value.includes('7')) {
                if (!formData.value[item]) {
                    checkRes = false
                    break;
                }
            }
        } else {
            //去掉logo  company_website
            if ((item != 'company_website' && item != 'logo') && !formData.value[item]) {
                checkRes = false
                break;
            }
        }

    }
    return checkRes;
}

const checkProductionAddress = () => {
    // 验证企业生产地址是否完整
    let checkRes = true
    if (companytype.value.includes('2')) {
        // 制造商需要填写生产地址
        console.log(companyAddressList.value);
        if (companyAddressList.value.length ==0) {
            checkRes = false
            return
        }
        // 只有制造商和供应商才有生产地址信息 --> 供应商不需要填写生产地址 2026-07-01
        for (const item in companyAddressList.value) {
            if (!companyAddressList.value[item].countryKey ||
                !companyAddressList.value[item].province ||
                !companyAddressList.value[item].province_code ||
                !companyAddressList.value[item].city ||
                !companyAddressList.value[item].address ||
                !companyAddressList.value[item].post) {
                checkRes = false
                break;
            }
        }
    }
    return checkRes;
}

const back = () => {
    // 返回上一步
    emits('backStep', formData.value)
}
const next = () => {
    let res = checkForm()
    console.log(res);
    if (!res) {
        showMessage('danger', getLangValue('base.requiredinformation'))
        return false
    }

    let res1 = checkProductionAddress()
    console.log(res1);
    if (!res1) {
        showMessage('danger', getLangValue('my.account','product_address_info'))
        return false
    }
    let res2 = checkContactAddress()
    console.log(res1);
    if (!res2) {
        showMessage('danger', getLangValue('base.requiredinformation'))
        return false
    }

    // 暂存信息 以及跳转到下一步
    emits('nextStep', [formData.value, companyAddressList.value, contact_address.value])
}

/**
 * 文件上传部分
 */

// const checkFile = (file) => {
//     let name = /^device\//.test(file.name)
//         ? file.name.substring(44)
//         : file.name;
//     let suffix = name.substring(name.lastIndexOf("."));
//     // 判断是否属于指定的类型
//     if (accept.indexOf(suffix) == -1) {
//         showMessage("danger", i18n.global.t("upload.notCorrectType"));
//         return false;
//     }
//     // 判断是否是同一个文件
//     let arr = formData.value.qualification_documents.filter(item => item.filname == name)
//     if (arr.length > 0) {
//         showMessage("danger", i18n.global.t("upload.notSameFile"));
//         return false;
//     }
//     return true;
// }
// const selectedFile = (id) => {
//     let idStr = '#' + id;
//     let fileMaxSize = 1024 * 1024 * 50
//     let dropzoneFile = document.querySelector(idStr).files[0];
//     if (!dropzoneFile) return;
//     if (dropzoneFile.size > fileMaxSize) {
//         showMessage("danger", i18n.global.t("upload.limit"));
//         document.getElementById("dropzoneFile").value = "";
//         return;
//     }
//     if (!checkFile(dropzoneFile)) {
//         document.getElementById("dropzoneFile").value = "";
//         return;
//     }
//     // console.log(dropzoneFile);
//     uploadFile(dropzoneFile)
//         .then((res) => {
//             if (id == 'qualification_documents') {
//                 formData.value.qualification_documents.push(res.data.payload);
//             } else {
//                 formData.value.logo = [] // 只有一个
//                 formData.value.logo.push(res.data.payload);
//                 // console.log(formData.value.logo);
//             }

//         })
//         .catch((e) => {
//             console.log(e);
//         });

// }
// const drop = (e) => {
//     let dropzoneFile = e.dataTransfer.files[0];
//     if (!dropzoneFile) return;
// }

const deleteFile = (file) => {
    Swal.fire({
        title: getLangValue("base.delete_alert_title"),
        text: getLangValue("base.delete_alert_info"),
        icon: "warning",
        showCancelButton: true,
        cancelButtonColor: "#f46a6a",
        confirmButtonColor: "#34c38f",
        confirmButtonText: getLangValue("base.done"),
        cancelButtonText: getLangValue("base.cancel"),
    }).then(async (result) => {
        if (result.isConfirmed) {
            const index = formData.value.qualification_documents.findIndex(item => item.filename == file.name)
            if (index > -1) {
                formData.value.qualification_documents.splice(index, 1);
            }
        }
    });

}
const deleteFileNew = (index, type = 0) => {
    Swal.fire({
        title: getLangValue("base.delete_alert_title"),
        text: getLangValue("base.delete_alert_info"),
        icon: "warning",
        showCancelButton: true,
        cancelButtonColor: "#f46a6a",
        confirmButtonColor: "#34c38f",
        confirmButtonText: getLangValue("base.done"),
        cancelButtonText: getLangValue("base.cancel"),
    }).then(async (result) => {
        if (result.isConfirmed) {
            // const index = formData.value.qualification_documents.findIndex(item => item.filename == file.name)
            if (type == 0) {
                formData.value.qualification_documents.splice(index, 1);
            } else {
                formData.value.logo.splice(index, 1);
            }
        }
    });

}

// const deleteFile1 = (url) => {
//     console.log(url);
//     const index = formData.value.logo.findIndex(item => item.url == url)
//     if (index > -1) {
//         formData.value.logo.splice(index, 1);
//     }
// }

const getFile = (data, idList) => {
    let arr = []
    for (let k in idList) {
        arr = [...arr, ...data.filter(item => item.id == idList[k])]
    }
    return arr
}
const setType = (filename) => {
    // 获取文件类型
    let fileType = filename.split('.').pop()
    if (fileType == 'jpg' || fileType == 'jpeg' || fileType == 'png' || fileType == 'gif') {
        return 'image'
    } else if (fileType == 'dwg' || fileType == 'dwt' || fileType == 'dxf' || fileType == 'dwf') {
        return 'cad'
    }
    return 'file'
}

const changeFile = (file) => {
    // console.log(file.raw.type);
    if (file.raw.type !== 'image/jpeg' && file.raw.type !== 'image/jpg' && file.raw.type !== 'image/png' && file.raw.type !== 'application/pdf') {
        showMessage('danger', getLangValue('upload.fileTypeLimit'))
        // console.log(uploadRef.value);
        // uploadRef.value.handleRemove(file)
        return false
    }
    if (file.raw.size / 1024 / 1024 > 50) {
        showMessage('danger', getLangValue('upload.fileSizeLimit'))
        // console.log(uploadRef.value);
        // uploadRef.value.handleRemove(file)
        return false
    }
    uploadFile(file.raw)
        .then((res) => {
            // res.data.payload.forEach(item => {
            //     item.type = setType(item.name)
            // })
            res.data.payload.type = setType(res.data.payload.filename)
            formData.value.qualification_documents.push(res.data.payload);
        })
        .catch((e) => {
            console.log(e);
        });
}
const changeFile1 = (file) => {
    if (file.raw.type !== 'image/jpeg' && file.raw.type !== 'image/jpg' && file.raw.type !== 'image/png') {
        showMessage('danger', getLangValue('upload.fileTypeLimit'))
        // console.log(uploadRef.value);
        // uploadRef.value.handleRemove(file)
        return false
    }
    if (file.raw.size / 1024 / 1024 > 50) {
        showMessage('danger', getLangValue('upload.fileSizeLimit'))
        // console.log(uploadRef.value);
        // uploadRef.value.handleRemove(file)
        return false
    }
    uploadFile(file.raw)
        .then((res) => {
            formData.value.logo.push(res.data.payload);
        })
        .catch((e) => {
            console.log(e);
        });
}

const showImage = (url) => {
    window.open(url, '_blank ');
}

const changeCountry1 = (key) => {
    // 选择国家 展示对应的key
    if (!contact_address.value[key].country) {
        contact_address.value[key].countryKey = ''
    } else {
        let arr = countryList.value.filter(item => item.zh === contact_address.value[key].country || item.en === contact_address.value[key].country)
        if (arr.length > 0) {
            contact_address.value[key].countryKey = arr[0].key
        }
    }
    // 如果是中国
    if (contact_address.value[key].countryKey == 'CN') {
        provinceList1.value[key] = [...AreaJson]
    }
}

const changeProvince1 = (key) => {
    cityList1.value[key] = []
    // console.log(companyAddressList.value[key].province);
    if (contact_address.value[key].province) {
        let arr = AreaJson.filter(item => item.name === contact_address.value[key].province)
        // console.log(arr);
        if (arr.length) {
            // 直辖市
            if (arr[0].city[0].name === contact_address.value[key].province) {
                // 获取区
                cityList1.value[key] = arr[0].city[0].area.map(item => { return { name: item } })
                oldCityList1.value[key] = [...cityList1.value[key]]
            } else {
                cityList1.value[key] = arr[0].city.map(item => { return { name: item.name } })
                oldCityList1.value[key] = [...cityList1.value[key]]
            }
            // console.log(cityList.value[key]);
        }
    }
}
const changeProvince = (key) => {
    cityList.value[key] = []
    // console.log(companyAddressList.value[key].province);
    if (companyAddressList.value[key].province) {
        let arr = AreaJson.filter(item => item.name === companyAddressList.value[key].province)
        // console.log(arr);
        if (arr.length) {
            // 直辖市
            if (arr[0].city[0].name === companyAddressList.value[key].province) {
                // 获取区
                cityList.value[key] = arr[0].city[0].area.map(item => { return { name: item } })
                oldCityList.value[key] = [...cityList.value[key]]
            } else {
                cityList.value[key] = arr[0].city.map(item => { return { name: item.name } })
                oldCityList.value[key] = [...cityList.value[key]]
            }
            // console.log(cityList.value[key]);
        }
    }
}

const filterProvince1 = (query, key) => {
    // 搜索省份  自带的搜索不管用  
    // console.log(query);
    if (query) {
        provinceList1.value[key] = AreaJson.filter((item) => {
            if (item.name.includes(query)) {
                return true
            }
        })
    } else {
        provinceList1.value[key] = [...AreaJson] //val为空时，还原数组
    }
}

const filterCity1 = (query, key) => {
    // 搜索省份  自带的搜索不管用 
    // console.log(query);
    if (query) {
        cityList1.value[key] = oldCityList1.value[key].filter((item) => {
            if (item.name.includes(query)) {
                return true
            }
        })
    } else {
        cityList1.value[key] = [...oldCityList1.value[key]] //val为空时，还原数组
    }
}

const onlyUppercase = (index) => {
    // 只允许大写字母
    companyAddressList.value[index].province_code = companyAddressList.value[index].province_code.replace(/[^A-Z]/g, ''); // 非大写字母的字符会被移除
    console.log(companyAddressList.value[index].province_code);
}

/**
 * 文件上传部分
 */

onMounted(() => {
    // console.log(companytype);
})

watch(detailInfo, (val) => {
    // formData.value.Enterprise_registered_country = val.place_of_incorporation
    formData.value.Enterprise_registered_countryKey = val.place_of_incorporation
    // getCountrykey(val.Enterprise_registered_country)
    // formData.value.Enterprise_registered_address = val.place_of_incorporation
    formData.value.Certificate_No = val.certificate_number
    //新增字段
    formData.value.company_qualification_certification_body = val.company_qualification_certification_body
    formData.value.company_qualification_validity_period = val.company_qualification_validity_period
    formData.value.company_website = val.company_website
    let fileList0 = val.company_qualification
    let fileList1 = val.company_logo ? [val.company_logo] : []
    let fileList = fileList0.concat(fileList1)
    fileList = [...new Set(fileList)]
    let imgIdStr = fileList.join(',')
    if (imgIdStr)
        getFileUrl({ attachments: imgIdStr }).then(resp => {
            if (resp) {
                resp.payload.forEach(item => {
                    item.type = setType(item.filename || item.name)
                })
                formData.value.qualification_documents = getFile(resp.payload, fileList0)
                if (val.company_logo)
                    formData.value.logo = getFile(resp.payload, fileList1)
            }
        })
    // 展示生产地址
    companyAddressList.value = val.company_address.map((item) => {
        return {
            id: item.id,
            country: item.name,
            countryKey: item.country,
            province: item.province,
            province_code: item.province_code,
            city: item.city,
            address: item.address1,
            post: item.postcode,
        }
    })
    if (companyAddressList.value.length) {
        companyAddressList.value.forEach((item, key) => {
            if (item.countryKey == 'CN') {
                changeCountry(key)
                changeProvince(key)
            }
        })
    }
    if (companyAddressList.value.length == 0) {
        companyAddressList.value = [{
            id: '',
            country: '',
            countryKey: '',
            province: '',
            province_code: '',
            city: '',
            address: '',
            post: '',
        }]
    }
    // 企业通讯地址
    contact_address.value = val.contact_address.map((item) => {
        return {
            id: item.id,
            country: item.name,
            countryKey: item.country,
            province: item.province,
            city: item.city,
            address: item.address1,
            post: item.postcode,
        }
    })
    if (contact_address.value.length) {
        contact_address.value.forEach((item, key) => {
            if (item.countryKey == 'CN') {
                changeCountry1(key)
                changeProvince1(key)
            }
        })
    }
    if (contact_address.value.length == 0) {
        contact_address.value = [{
            id: '',
            country: '',
            countryKey: '',
            province: '',
            city: '',
            address: '',
            post: '',
        }]
    }

})  
</script>
<template>
    <form class="mt-5">
        <div class="row  d-flex justify-content-center my-form2" style="width: 820px; margin:  0 auto;">
            <div class="col-100 my-3">
                <div class="d-flex align-items-center">
                    <label class="form-label mx-3" style="min-width: 200px;display: flex; align-items: center;">
                        <div style="display: inline-block; word-break: keep-all; ">{{
                            getLangValue('my.account','form_Enterprise_registered_address') }}</div>
                        <span class="text-danger">*</span>
                    </label>
                    <div class="input-group  d-flex">
                        <!-- <el-select
                                :class="[(isCheckForm && !formData.Enterprise_registered_country) && 'is-invalid1']"
                                @change="changeAddressCountry" v-model="formData.Enterprise_registered_country"
                                filterable placeholder=" " size="large" style="width: 100%;" clearable
                                :filter-method="filterCountry">
                                <template #prefix>
                                    <country-flag :country='formData.Enterprise_registered_countryKey' size='small' />
                                </template>
<el-option v-for="item1 in countryList" :key="item1.key" :label="item1.zh" :value="item1.zh">
    <country-flag :country='item1.key' size='small' /> {{ item1.zh }}
</el-option>
</el-select> -->
                        <div class="input-group-text p-0"
                            :class="[(isCheckForm && !formData.Enterprise_registered_countryKey) && 'is-invalid1']">
                            <el-select style="width: 120px;"
                                :class="[(isCheckForm && !formData.Enterprise_registered_countryKey) && 'is-invalid1']"
                                v-model="formData.Enterprise_registered_countryKey" filterable placeholder=" "
                                size="large" clearable :filter-method="filterCountry">
                                <template #prefix>
                                    <country-flag :country='formData.Enterprise_registered_countryKey' size='small' />
                                </template>
                                <el-option v-for="item1 in countryList" :key="item1.key" :label="i18n.global.locale == 'en' ? item1.en:  item1.zh"
                                    :value="item1.key">
                                    <country-flag :country='item1.key' size='small' /> {{ i18n.global.locale == 'en' ? item1.en:  item1.zh }}
                                </el-option>
                            </el-select>
                        </div>
                        <input disabled clearable class="form-control flex-1"
                            v-model="formData.Enterprise_registered_countryKey"
                            :class="[(isCheckForm && !formData.Enterprise_registered_countryKey) && 'is-invalid']"
                            required />
                    </div>
                </div>
            </div>

            <div class="col-100 my-3">
                <div class="d-flex align-items-center">
                    <label class="form-label mx-3" style="min-width: 200px;">
                        <span>{{ getLangValue('my.account','form_Certificate_No') }}</span>
                        <span class="text-danger">*</span>
                    </label>
                    <input :class="[(isCheckForm && !formData.Certificate_No) && 'is-invalid']"
                        v-model="formData.Certificate_No" :placeholder="getLangValue('my.account','form_Certificate_No')"
                        class="form-control" style="display: inline;" />
                </div>
            </div>


            <div class="col-100 my-3">
                <div class="d-flex align-items-center ">
                    <label class="form-label mx-3" style="min-width: 200px;">
                        <span>{{ getLangValue('my.account','form_qualification_documents') }}</span>
                        <span class="text-danger">*</span>
                    </label>
                    <!-- 上传框 -->
                    <!-- <div class="d-flex align-items-center justify-content-between p-2" style="flex: 1 1 0%; border: 1px solid rgb(206, 212, 218); border-radius: 4px;">
                        <div class="product-img-slider d-flex justify-content-between p-1 me-1"
                            style="overflow-y: auto; max-width: 330px; height: 200px; flex-wrap:wrap"
                            v-if="formData.qualification_documents.length">
                            <div class="file-view" v-for="(image, kk) in formData.qualification_documents" :key="kk"
                                style="display: inline-block; border: 1px solid #E9EBEC;  border-radius: 4px; position: relative; width: 150px; height: 100px;">
                                <i v-if="image.type == 'file'" class="ri-file-text-line"
                                    style="font-size: 110px;color:#0AB39C"></i>
                                <img v-else :src="image.url" alt="" @click="handleImgPreview(image.url)"
                                    class="cursor-pointer" />
                                <fileActionCom :image="image" :showDelete="true" @delete="deleteFile" />
                            </div>
                        </div>
                        <DropZone ipt-id="qualification_documents" :accept="accept" @drop.prevent="drop"
                            @change.prevent="selectedFile('qualification_documents')"
                            style="min-height: 200px;" limit="50M" />
                    </div> -->
                    <div class="p-2" style="flex: 1 1 0%; border-radius: 4px;">

                        <div class="product-img-slider  justify-content-between p-1 me-1"
                            v-if="formData.qualification_documents.length">
                            <div class="d-flex align-items-center justify-content-between"
                                v-for="(image, kk) in formData.qualification_documents" :key="kk"
                                style="height: 30px; line-height: 30px;  ">
                                <div>
                                    <img v-if="image.type == 'image'" :src="image.url" style="width: 43px;"
                                        class="me-2" />
                                    <a class="cursor-pointer" @click="showImage(image.url)">{{ image.filename ||
                                        image.name
                                        }}</a>
                                </div>
                                <i class="ri-delete-bin-line ms-2 cursor-pointer" style="color:red"
                                    @click="deleteFileNew(i)"></i>
                            </div>
                        </div>
                        <el-upload style="display: block;" ref="uploadRef" class="upload-demo" multiple
                            :show-file-list="false" v-else :auto-upload="false" :before-remove="deleteFile"
                            :accept="'image/png, image/jpeg,image/jpg,application/pdf'" :on-change="changeFile">
                            <!-- <span class="mx-2" ></span> -->
                            <button type="button" class="btn"
                                :class="[(isCheckForm && (formData.qualification_documents == null || formData.qualification_documents.length == 0)) && 'is-invalid']"
                                style="color:#6691E7; border: 1px solid #6691E7;"><i
                                    class=" ri-upload-2-line me-2"></i>{{
                                        getLangValue('upload.uploadedFile1') }}</button>
                            <div style="color: #9599AD;">{{ getLangValue('upload.fileTypeLimit1') }}</div>
                        </el-upload>
                    </div>
                </div>
            </div>
            <!-- logo -->
            <div class="col-100 my-3">
                <div class="d-flex align-items-center ">
                    <label class="form-label mx-3" style="min-width: 200px;">
                        <span>{{ getLangValue('my.account','logo') }}</span>
                        <!-- <span class="text-danger">*</span> -->
                    </label>
                    <!-- 上传框 -->
                    <!-- <div class="d-flex align-items-center justify-content-between p-2"
                        style="flex:1; border: 1px solid #ced4da;border-radius: 4px;">
                        <div class="product-img-slider d-flex justify-content-between p-1 me-1"
                            style="overflow-y: auto; max-width: 330px; height: 200px; flex-wrap:wrap"
                            v-if="formData.logo.length">
                            <div class="file-view" v-for="(image, kk) in formData.logo" :key="kk"
                                style="display: inline-block; border: 1px solid #E9EBEC;  border-radius: 4px; position: relative; width: 150px; height: 100px;">
                                <i v-if="image.type == 'file'" class="ri-file-text-line"
                                    style="font-size: 110px;color:#0AB39C"></i>
                                <img v-else :src="image.url" alt="" @click="handleImgPreview(image.url)"
                                    class="cursor-pointer" />
                                <fileActionCom :image="image" :showDelete="true" @delete="deleteFile1" />
                            </div>
                        </div>
                        <DropZone ipt-id="qualification_documents1" :accept="accept" @drop.prevent="drop"
                            @change.prevent="selectedFile('qualification_documents1')" style="min-height: 200px"
                            limit="50M" />
                    </div> -->
                    <div class="p-2" style="flex: 1 1 0%;  border-radius: 4px;">
                        <div class="product-img-slider  justify-content-between p-1 me-1" v-if="formData.logo.length">
                            <div class="d-flex align-items-center justify-content-between"
                                v-for="(image, kk) in formData.logo" :key="kk"
                                style="height: 30px; line-height: 30px;  ">
                                <div>
                                    <img :src="image.url" style="width: 43px;" class="me-2" />
                                    <a class="cursor-pointer" @click="showImage(image.url)">{{ image.filename ||
                                        image.name
                                        }}</a>
                                </div>
                                <i class="ri-delete-bin-line ms-2 cursor-pointer" style="color:red"
                                    @click="deleteFileNew(i, 1)"></i>

                            </div>
                        </div>
                        <el-upload v-else ref="uploadRef1" class="upload-demo" multiple :show-file-list="false"
                            :auto-upload="false" :accept="'image/png, image/jpeg,image/jpg'" :on-change="changeFile1">
                            <!-- <span class="mx-2" style="color:#0ab39c">{{ getLangValue('upload.uploadedFile1Imag') }}</span> -->
                            <button type="button" class="btn" style="color:#6691E7; border: 1px solid #6691E7;"><i
                                    class=" ri-upload-2-line me-2"></i>{{ getLangValue('upload.uploadedFile1') }}</button>
                            <div style="color: #9599AD;">{{ getLangValue('upload.fileTypeLimit2') }}</div>
                        </el-upload>

                    </div>
                </div>
            </div>

            <!-- 新增字段 请输入公司的网站链接 -->
            <div class="col-100 my-3">
                <div class="d-flex align-items-center">
                    <label class="form-label mx-3" style="min-width: 200px;">
                        <span>{{ getLangValue('my.account','form_company_link') }}</span>
                        <span class="text-danger"></span>
                    </label>
                    <input v-model="formData.company_website" :placeholder="getLangValue('my.account','form_test_date_placeholder3')"
                        class="form-control" style="display: inline;" />
                </div>
            </div>

            <!-- 新增字段 机构资质认证有效期 -->
            <div class="col-100 my-3" v-if="companytype.includes('7')">
                <div class="d-flex align-items-center">
                    <label class="form-label mx-3" style="min-width: 200px; display: flex; align-items: center;">
                        <div style="display: inline-block;width: 125px; word-break: keep-word; ">{{
                            getLangValue('my.account','form_qualification_certification') }}</div>
                        <span class="text-danger" v-if="companytype.includes('7')">*</span>
                    </label>
                    <!-- <input :class="[(isCheckForm && !formData.company_qualification_validity_period) && 'is-invalid']" v-model="formData.company_qualification_validity_period"
                            :placeholder="getLangValue('my.account','form_test_date_placeholder1')" class="form-control"
                            style="display: inline;" /> -->
                    <!-- <flat-pickr v-model="formData.company_qualification_validity_period"
                        style="background-color: unset;display: inline;"
                        :class="[(isCheckForm && companytype.includes('7') && !formData.company_qualification_validity_period) && 'is-invalid']"
                        :placeholder="getLangValue('my.account','form_test_date_placeholder1')"
                        :config="{ enableTime: false, dateFormat: 'Y-m-d' }" class="form-control">
                    </flat-pickr> -->

                    <el-date-picker :shortcuts="shortcuts" style="height: 37.5px; width: 100%;"
                        v-model="formData.company_qualification_validity_period"
                        :placeholder="getLangValue('my.account','form_test_date_placeholder1')" size="large" value-format="YYYY-MM-DD"
                        :class="[(isCheckForm && companytype.includes('7') && !formData.company_qualification_validity_period) && 'is-invalid']" />
                </div>
            </div>
            <!-- 新增字段 机构资质认证机构 -->
            <div class="col-100 my-3" v-if="companytype.includes('7')">
                <div class="d-flex align-items-center">
                    <label class="form-label mx-3" style="min-width: 200px;display: flex; align-items: center;">
                        <div style="display: inline-block;width: 115px; word-break: keep-all; ">{{
                            getLangValue('my.account','form_qualification_certification1') }}</div>
                        <span class="text-danger" v-if="companytype.includes('7')">*</span>
                    </label>
                    <input 
                        :class="[(isCheckForm && companytype.includes('7') && !formData.company_qualification_certification_body) && 'is-invalid']"
                        v-model="formData.company_qualification_certification_body"
                        :placeholder="getLangValue('my.account','form_test_date_placeholder2')" class="form-control"
                        style="display: inline;" />
                </div>
            </div>
            <!-- 企业通讯地址 -->
            <div v-for="(item, key) in contact_address " :key="key">
                <div class="d-flex align-items-center">
                    <div class="mx-3" style="min-width: 200px;color: #212529; font-weight: 600; text-align: right;">
                        {{ getLangValue('my.account','contact_address') }}
                    </div>
                    <!-- <i class="ri-delete-bin-fill cursor-pointer" style="color: red;" v-if="key > 0"
                        @click="removeProductAddress(key)"></i> -->
                </div>
                <div class="col-100 my-3">
                    <div class="d-flex align-items-center">
                        <label class="form-label mx-3" style="min-width: 200px;">
                            <span>{{ getLangValue('my.account','form_country') }}</span>
                            <span class="text-danger">*</span>
                        </label>
                        <div class="input-group  d-flex">
                            <div class="input-group-text p-0" style="width: 120px;"
                                :class="[(isCheckForm && !item.country) && 'is-invalid1']">

                                <el-select :class="[(isCheckForm && !item.country) && 'is-invalid1']"
                                    v-model="item.country" filterable placeholder="" @change='changeCountry1(key)'
                                    size="large" style="width: 100%;" clearable :filter-method="filterCountry">
                                    <template #prefix>
                                        <!-- 将前置插槽数据设置为label的值 -->
                                        <country-flag :country='item.countryKey' size='small' />
                                    </template>
                                    <el-option v-for="item1 in countryList" :key="item1.key" :label="i18n.global.locale == 'en' ? item1.en:  item1.zh"
                                        :value="i18n.global.locale == 'en' ? item1.en:  item1.zh">
                                        <country-flag :country='item1.key' size='small' /> {{ i18n.global.locale == 'en' ? item1.en:  item1.zh}}
                                    </el-option>
                                </el-select>
                            </div>
                            <input disabled clearable class="form-control flex-1" v-model="item.countryKey"
                                :class="[(isCheckForm && !item.countryKey) && 'is-invalid']" required />
                        </div>
                    </div>
                </div>
                <div class="col-100 my-3">
                    <div class="d-flex align-items-center">
                        <label class="form-label mx-3" style="min-width: 200px;">
                            <span>{{ getLangValue('my.account','form_province') }}</span>
                            <span class="text-danger">*</span>
                        </label>
                        <el-select v-if="item.countryKey == 'CN'"
                            :class="[(isCheckForm && !item.province) && 'is-invalid']" @change="changeProvince1(key)"
                            v-model="item.province" filterable placeholder="" size="large" style="width: 100%;"
                            :filter-method="(query) => filterProvince1(query, key)" clearable>
                            <el-option v-for="item1 in provinceList1[key]" :key="item1.name" :label="item1.name"
                                :value="item1.name">
                            </el-option>
                        </el-select>
                        <input v-else clearable class="form-control flex-1" v-model="item.province"
                            :class="[(isCheckForm && !item.province) && 'is-invalid']" required />
                    </div>
                </div>
                <div class="col-100 my-3">
                    <div class="d-flex align-items-center">
                        <label class="form-label mx-3" style="min-width: 200px;">
                            <span>{{ getLangValue('my.account','form_City') }}</span>
                            <span class="text-danger">*</span>
                        </label>
                        <el-select v-if="item.countryKey == 'CN'" :class="[(isCheckForm && !item.city) && 'is-invalid']"
                            v-model="item.city" filterable placeholder="" size="large" style="width: 100%;"
                            :filter-method="(query) => filterCity1(query, key)" clearable>
                            <el-option v-for="item1 in cityList1[key]" :key="item1.name" :label="item1.name"
                                :value="item1.name">
                            </el-option>
                        </el-select>
                        <input v-else clearable class="form-control flex-1" v-model="item.city"
                            :class="[(isCheckForm && !item.city) && 'is-invalid']" required />
                    </div>
                </div>
                <div class="col-100 my-3">
                    <div class="d-flex align-items-center">
                        <label class="form-label mx-3" style="min-width: 200px;">
                            <span>{{ getLangValue('my.account','form_address') }}</span>
                            <span class="text-danger">*</span>
                        </label>
                        <input clearable class="form-control flex-1" v-model="item.address"
                            :class="[(isCheckForm && !item.address) && 'is-invalid']" required />
                    </div>
                </div>
                <div class="col-100 my-3">
                    <div class="d-flex align-items-center">
                        <label class="form-label mx-3" style="min-width: 200px;">
                            <span>{{ getLangValue('my.account','form_post') }}</span>
                            <span class="text-danger">*</span>
                        </label>
                        <input clearable class="form-control flex-1" v-model="item.post"
                            :class="[(isCheckForm && !item.post) && 'is-invalid']" required />
                    </div>
                </div>
            </div>
            <!-- 企业生产地址 -->
            <template v-if="productCompanyIdList.some(item => companytype.includes(item))">
                <div v-for="(item, key) in companyAddressList" :key="key">
                    <div class="d-flex align-items-center">
                        <div class="mx-3" style="min-width: 200px;color: #212529; font-weight: 600; text-align: right;">
                            {{ getLangValue('my.account','enterprise_production_address') }} {{ key + 1 }}
                        </div>
                        <i class="ri-delete-bin-fill cursor-pointer" style="color: red;" v-if="(key > 0 && companytype.includes('2')) || ( !companytype.includes('2') && productCompanyIdList1.some(item => companytype.includes(item)))"
                            @click="removeProductAddress(key)"></i>
                    </div>
                    <div class="col-100 my-3">
                        <div class="d-flex align-items-center">
                            <label class="form-label mx-3" style="min-width: 200px;">
                                <span>{{ getLangValue('my.account','form_country') }}</span>
                                <span class="text-danger"
                                    v-if="companytype.includes('2')">*</span>
                            </label>
                            <div class="input-group  d-flex">
                                <div class="input-group-text p-0" style="width: 120px;"
                                    :class="[(isCheckForm && (companytype.includes('2')) && !item.country) && 'is-invalid1']">

                                    <el-select
                                        :class="[(isCheckForm && (companytype.includes('2')) && !item.country) && 'is-invalid1']"
                                        v-model="item.country" filterable placeholder="" @change='changeCountry(key)'
                                        size="large" style="width: 100%;" clearable :filter-method="filterCountry">
                                        <template #prefix>
                                            <!-- 将前置插槽数据设置为label的值 -->
                                            <country-flag :country='item.countryKey' size='small' />
                                        </template>
                                        <el-option v-for="item1 in countryList" :key="item1.key" :label="i18n.global.locale == 'en' ? item1.en:  item1.zh"
                                            :value="i18n.global.locale == 'en' ? item1.en:  item1.zh">
                                            <country-flag :country='item1.key' size='small' /> {{i18n.global.locale == 'en' ? item1.en:  item1.zh }}
                                        </el-option>
                                    </el-select>
                                </div>
                                <input disabled clearable class="form-control flex-1" v-model="item.countryKey"
                                    :class="[(isCheckForm && (companytype.includes('2')) && !item.countryKey) && 'is-invalid']"
                                    required />
                            </div>
                        </div>
                    </div>
                    <div class="col-100 my-3">
                        <div class="d-flex align-items-center">
                            <label class="form-label mx-3" style="min-width: 200px;">
                                <span>{{ getLangValue('my.account','form_province') }}</span>
                                <span class="text-danger"
                                    v-if="companytype.includes('2')">*</span>
                            </label>
                            <el-select v-if="item.countryKey == 'CN'"
                                :class="[(isCheckForm && (companytype.includes('2')) && !item.province) && 'is-invalid']"
                                @change="changeProvince(key)" v-model="item.province" filterable placeholder=""
                                size="large" style="width: 100%;" :filter-method="(query) => filterProvince(query, key)"
                                clearable>
                                <el-option v-for="item1 in provinceList[key]" :key="item1.name" :label="item1.name"
                                    :value="item1.name">
                                </el-option>
                            </el-select>
                            <input v-else clearable class="form-control flex-1" v-model="item.province"
                                :class="[(isCheckForm && (companytype.includes('2')) && !item.province) && 'is-invalid']"
                                required />
                        </div>
                    </div>
                    <!-- 2024-10-24 新增省市区代码 -->
                    <div class="col-100 my-3">
                        <div class="d-flex align-items-center">
                            <label class="form-label mx-3" style="min-width: 200px;">
                                <span>{{ getLangValue('my.account','form_province_code') }}</span>
                                <span class="text-danger"
                                    v-if="companytype.includes('2')">*</span>
                            </label>
                            <input clearable class="form-control flex-1" v-model="item.province_code"
                                @blur="onlyUppercase(key)" :placeholder="getLangValue('my.account','form_province_code_placeholder')"
                                :class="[(isCheckForm && (companytype.includes('2')) && !item.province_code) && 'is-invalid']"
                                required />
                        </div>
                    </div>
                    <div class="col-100 my-3">
                        <div class="d-flex align-items-center">
                            <label class="form-label mx-3" style="min-width: 200px;">
                                <span>{{ getLangValue('my.account','form_City') }}</span>
                                <span class="text-danger"
                                    v-if="companytype.includes('2')">*</span>
                            </label>
                            <el-select v-if="item.countryKey == 'CN'"
                                :class="[(isCheckForm && (companytype.includes('2')) && !item.city) && 'is-invalid']"
                                v-model="item.city" filterable placeholder="" size="large" style="width: 100%;"
                                :filter-method="(query) => filterCity(query, key)" clearable>
                                <el-option v-for="item1 in cityList[key]" :key="item1.name" :label="item1.name"
                                    :value="item1.name">
                                </el-option>
                            </el-select>
                            <input v-else clearable class="form-control flex-1" v-model="item.city"
                                :class="[(isCheckForm && (companytype.includes('2')) && !item.city) && 'is-invalid']"
                                required />
                        </div>
                    </div>
                    <div class="col-100 my-3">
                        <div class="d-flex align-items-center">
                            <label class="form-label mx-3" style="min-width: 200px;">
                                <span>{{ getLangValue('my.account','form_address') }}</span>
                                <span class="text-danger"
                                    v-if="companytype.includes('2')">*</span>
                            </label>
                            <input clearable class="form-control flex-1" v-model="item.address"
                                :class="[(isCheckForm && (companytype.includes('2')) && !item.address) && 'is-invalid']"
                                required />
                        </div>
                    </div>
                    <div class="col-100 my-3">
                        <div class="d-flex align-items-center">
                            <label class="form-label mx-3" style="min-width: 200px;">
                                <span>{{ getLangValue('my.account','form_post') }}</span>
                                <span class="text-danger"
                                    v-if="companytype.includes('2')">*</span>
                            </label>
                            <input clearable class="form-control flex-1" v-model="item.post"
                                :class="[(isCheckForm && (companytype.includes('2')) && !item.post) && 'is-invalid']"
                                required />
                        </div>
                    </div>
                </div>
                <div class="col-100 mb-3">
                    <div class="d-flex align-items-center">
                        <label class="form-label mx-3" style="min-width: 200px;"></label>
                        <div @click="addAddress"
                            class="d-flex align-items-center justify-content-center cursor-pointer px-1" style="min-width: 104px; 
                        border:1px dashed #0AB39C;
                        background-color: unset;
                        height: 24px;
                        color: #0AB39C;
                        font-size: 12px;
                        border-radius: 2px;
                        text-align: center;
                    ">
                            <i class="ri-add-fill"></i>{{ getLangValue('my.account','btn_add_production_address') }}
                        </div>
                    </div>
                </div>
            </template>
            <div class="d-flex  mt-3">
                <label class="form-label mx-3" style="min-width: 200px;"></label>
                <div class="d-flex align-items-center justify-content-center" style="flex: 1;">
                    <b-button class="mx-2" variant="success" @click="back" style="width: 104px;height: 38px;">
                        {{ getLangValue('my.account','btn_back') }}
                    </b-button>
                    <b-button class="mx-2" variant="success" @click="next" style="width: 104px;height: 38px;">
                        {{ getLangValue('my.account','btn_submit') }}
                    </b-button>
                </div>
            </div>
        </div>
    </form>
</template>
<style lang="scss" scoped>
.my-form2 {
    :deep(.el-select__placeholder) {
        color: #888a98 !important;
        font-size: 13px !important;
    }

    :deep(.input-group-text .el-select__wrapper) {
        // border-radius: 0px 0.25rem 0.25rem 0;
        box-shadow: unset !important;
    }

    .is-invalid {
        border: 1px solid #f06548 !important;
        border-radius: 4px;

    }

    :deep(.is-invalid .el-input__wrapper) {
        border: 1px solid #f06548 !important;
    }

    .is-invalid1 {
        border: 1px solid #f06548;
        border-right: unset !important;
        // border-radius: 4px;
    }

    .input-group-text.is-invalid1 {
        border: unset !important;
    }

    .form-label {
        text-align: right;
        width: 200px !important;
        margin-bottom: unset !important;
    }

    .form-control {
        color: #888a97;
    }

    :deep(.el-upload) {
        display: block;
    }
}
</style>